import { render, staticRenderFns } from "./KTextarea.vue?vue&type=template&id=210dfa74"
import script from "./KTextarea.vue?vue&type=script&lang=js"
export * from "./KTextarea.vue?vue&type=script&lang=js"
import style0 from "./KTextarea.vue?vue&type=style&index=0&id=210dfa74&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})
